import React__default, { createElement, useState, useEffect, useCallback, Fragment } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { Text, ValidatingInput, Flex } from '@it25syv/25syv-ui';
import omit from 'lodash/omit';
import pick from 'lodash/pick';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13;
var SignUpWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n    height: auto;\n    min-height: 100%;\n    box-sizing: border-box;\n    display: block;\n    background: ", ";\n    @media screen and (max-width: 480px) {\n        width: 100%;\n    }\n"])), function (props) {
  return props.theme.colors.bg;
});
var SignUpTop = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    height: auto;\n    min-height: 35px;\n    width: 100%;\n    display: flex;\n    margin-bottom: 10px;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    box-sizing: border-box;\n    position: relative;\n"])));
var DefaultBtn = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n    width: 45px;\n    height: 45px;\n    border-radius: 5px;\n    color: ", ";\n    background: ", ";\n    transition: all 0.3s ease;\n    cursor: pointer;\n    @media screen and (max-width: 1024px) {\n        background: ", ";\n    }\n    &:hover {\n        background: ", ";\n    }\n"])), function (props) {
  return props.theme.colors.primaryAction;
}, function (props) {
  return props.theme.colors.bg;
}, function (props) {
  return props.theme.name === 'default' ? props.theme.colors.primaryActionHover : props.theme.colors.bgDarker;
}, function (props) {
  return props.theme.name === 'default' ? props.theme.colors.primaryActionHover : props.theme.colors.bgDarker;
});
var CloseSignupBtn = styled(DefaultBtn)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    top: -5px;\n    right: -5px;\n"])));
var BackBtn = styled(DefaultBtn)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    top: -5px;\n    left: -5px;\n"])));
var RadioWrapper = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n    margin: ", ";\n    width: 100%;\n    box-sizing: border-box;\n    display: flex;\n    justify-content: space-between;\n    align-items: ", ";\n    flex-wrap: ", ";\n    div {\n        margin: ", ";\n        box-sizing: border-box;\n        width: ", ";\n        display: flex;\n        justify-content: flex-start;\n        align-items: center;\n        &:first-child {\n            margin-top: 0;\n            margin-right: 40px;\n        }\n    }\n    input {\n        cursor: pointer;\n        -webkit-appearance: none;\n        -moz-appearance: none;\n        appearance: none;\n        position: relative;\n        height: 20px;\n        width: 20px;\n        font-size: 16px;\n        border-radius: 100%;\n        border: 1px solid ", ";\n        transition: all 0.3s linear;\n        outline: none;\n        background: ", ";\n        margin: 0 14px 0 0;\n        flex-shrink: 0;\n        &:checked {\n            border: 7px solid ", ";\n        }\n    }\n    label {\n        cursor: pointer;\n        font-size: 16px;\n        color: ", ";\n    }\n"])), function (_ref) {
  var margin = _ref.margin;
  return margin || '0 auto';
}, function (_ref2) {
  var alignItems = _ref2.alignItems;
  return alignItems || 'center';
}, function (_ref3) {
  var wrap = _ref3.wrap;
  return wrap || 'wrap';
}, function (_ref4) {
  var marginInside = _ref4.marginInside;
  return marginInside || '20px 0 0';
}, function (_ref5) {
  var radioWidth = _ref5.radioWidth;
  return radioWidth || '49%';
}, function (props) {
  return props.theme.colors.primaryAction;
}, function (props) {
  return props.theme === 'default' ? props.theme.colors.bg : props.theme.colors.bgDarker;
}, function (props) {
  return props.theme.colors.active;
}, function (props) {
  return props.theme.colors.basic;
});
var TextRulesWrapper = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    position: relative;\n    padding: 22px 20px 22px;\n    margin: 32px auto 20px;\n    background: ", ";\n    border-radius: 5px;\n    box-sizing: border-box;\n    border: 1px solid\n        ", ";\n    a {\n        line-height: 20px;\n        font-size: ", ";\n        color: ", ";\n    }\n"])), function (props) {
  return props.theme.colors.bgDarker;
}, function (props) {
  return props.valid ? props.theme.colors.active : props.theme.colors.bgDarker;
}, function (_ref6) {
  var linkFontSize = _ref6.linkFontSize;
  return linkFontSize || '12px';
}, function (props) {
  return props.theme.colors.link;
});
var NextButtonDefault = styled.button(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n    background: ", ";\n    color: ", ";\n    opacity: 1;\n    bottom: 0;\n    width: 100%;\n    border-radius: 8px;\n    font-size: 16px;\n    height: 54px;\n    font-weight: ", ";\n    border: none;\n    cursor: pointer;\n"])), function (props) {
  return props.disabled ? props.theme.colors.secondary : props.theme.colors.secondaryAction;
}, function (props) {
  return props.disabled ? props.theme.colors.primaryAction : props.theme.colors.basic;
}, function (props) {
  return props.theme.fontWeight;
});
var NextButton = styled(NextButtonDefault)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteralLoose(["\n    @supports (position: sticky) {\n        position: sticky;\n    }\n    @supports not (position: sticky) {\n        position: relative;\n    }\n    bottom: 0;\n"])));
var FourthStepBtn = styled.button(_templateObject10 || (_templateObject10 = _taggedTemplateLiteralLoose(["\n    position: relative;\n    height: 54px;\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    outline: none;\n    font-size: 16px;\n    font-weight: ", ";\n    font-family: ", ";\n    background: ", ";\n    cursor: pointer;\n    border: ", ";\n    transition: all 0.3s ease-out 0s;\n    border-radius: 8px;\n    margin: ", ";\n    color: ", ";\n    &:hover {\n        color: ", ";\n        background: ", ";\n    }\n"])), function (props) {
  return props.theme.fontWeight;
}, function (props) {
  return props.theme.fontFamily;
}, function (_ref7) {
  var mitid = _ref7.mitid;
  return mitid ? '#1a49d5' : '#e5ebf5';
}, function (_ref8) {
  var mitid = _ref8.mitid;
  return mitid ? '1px solid #1a49d5' : '1px solid #caced6';
}, function (_ref9) {
  var margin = _ref9.margin;
  return margin || '25px auto 0';
}, function (_ref10) {
  var mitid = _ref10.mitid;
  return mitid ? '#fff' : '#333';
}, function (_ref11) {
  var mitid = _ref11.mitid;
  return mitid ? '#fff' : '#333';
}, function (_ref12) {
  var mitid = _ref12.mitid;
  return mitid ? '#1841ba' : '#caced6';
});
var ExpanderWrapper = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: space-between;\n"])));
var ExpanderContent = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n    gap: 12px;\n"])));
var InfoBox = styled.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteralLoose(["\n    background: ", ";\n    border: 1px solid ", ";\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 16px;\n    padding: 0 16px;\n"])), function (props) {
  return props.theme.colors.bgBlue;
}, function (props) {
  return props.theme.colors.borderBlue;
});

var _templateObject$1, _templateObject2$1, _templateObject3$1;
var Wrapper = styled.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    box-sizing: border-box;\n"])));
var StepsWrapper = styled.div(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n"])));
var ProgressLine = styled.div(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    display: block;\n    box-sizing: border-box;\n    border-radius: 7px;\n    background: ", ";\n    padding: 3px 4px;\n    div {\n        height: 6px;\n        border-radius: 3px;\n        width: ", "%;\n        background: ", ";\n        transition: all 0.3s ease;\n    }\n"])), function (props) {
  return props.theme.colors.bgDarker;
}, function (_ref) {
  var _ref$progress = _ref.progress,
      progress = _ref$progress === void 0 ? 5 : _ref$progress;
  return progress;
}, function (_ref2) {
  var _ref2$progressColor = _ref2.progressColor,
      progressColor = _ref2$progressColor === void 0 ? '#FFD401' : _ref2$progressColor;
  return progressColor;
});

var Stepper = function Stepper(_ref3) {
  var _ref3$currentStep = _ref3.currentStep,
      currentStep = _ref3$currentStep === void 0 ? 1 : _ref3$currentStep,
      _ref3$steps = _ref3.steps,
      steps = _ref3$steps === void 0 ? [] : _ref3$steps,
      _ref3$progressColor = _ref3.progressColor,
      progressColor = _ref3$progressColor === void 0 ? '#FFD401' : _ref3$progressColor,
      selectStep = _ref3.selectStep,
      submitHandlerStep3 = _ref3.submitHandlerStep3,
      theme = _ref3.theme;

  var getProgressLength = function getProgressLength(currentStep, length) {
    return currentStep / length * 100;
  };

  var toStep = function toStep(step) {
    if (step === 4) {
      submitHandlerStep3(function () {
        return selectStep(step);
      });
    } else {
      selectStep(step);
    }
  };

  return /*#__PURE__*/React__default.createElement(Wrapper, null, /*#__PURE__*/React__default.createElement(StepsWrapper, null, steps.map(function (step, index) {
    return /*#__PURE__*/React__default.createElement(Text, {
      padding: "7px 0 14px",
      center: true,
      key: index,
      color: currentStep === index + 1 ? theme.colors.basic : theme.colors.primaryAction,
      decoration: currentStep > index + 1 ? 'line-through' : 'none',
      style: {
        cursor: 'pointer',
        margin: 0,
        fontWeight: theme.fontWeight,
        fontSize: '14px'
      },
      onClick: function onClick() {
        return toStep(index + 1);
      }
    }, step);
  })), /*#__PURE__*/React__default.createElement(ProgressLine, {
    progress: getProgressLength(currentStep, steps.length),
    progressColor: progressColor
  }, /*#__PURE__*/React__default.createElement("div", null)));
};

var thousandsDots = function thousandsDots(value) {
  if (value === undefined || value === null) {
    return value;
  }

  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};
function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
var hasNumber = /\d/gi;
var cutEmptyValues = function cutEmptyValues(value) {
  return value.replace(/\s/g, '');
};

var jsonSerializer = function jsonSerializer(data) {
  return JSON.stringify(data);
};

var formSerializer = function formSerializer(data) {
  var p = Object.keys(data).map(function (key) {
    return data[key] ? key + "=" + decodeURIComponent(data[key].toString()) : '';
  });
  return p.join('&');
};

var dataSerializers = {
  'application/json': jsonSerializer,
  'application/x-www-form-urlencoded': formSerializer,
  'multipart/form-data': jsonSerializer,
  'multipart/form-data; boundary=----DerbyRequestBoundary----': jsonSerializer
};

var makeRequest = function makeRequest(requestMethod, url, data, fetchParams, headerParams) {
  if (data === void 0) {
    data = {};
  }

  if (fetchParams === void 0) {
    fetchParams = {};
  }

  if (headerParams === void 0) {
    headerParams = {};
  }

  var params = _extends({
    headers: _extends({
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Cache: 'no-cache'
    }, headerParams),
    credentials: 'include',
    method: requestMethod
  }, fetchParams);

  if (requestMethod === 'post') {
    params.body = dataSerializers[params.headers['Content-Type']](data);
  } else if (requestMethod === 'get' && data) {
    var p = Object.keys(data).map(function (key) {
      return key + "=" + decodeURIComponent(data[key]);
    });
    url = url + (p.length ? '?' : '') + p.join('&');
  }

  return fetch(url, params);
};

var _templateObject$2, _templateObject2$2, _templateObject3$2, _templateObject4$1, _templateObject5$1, _templateObject6$1;
var TabsLabel = styled(Text)(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n"])), function (props) {
  return props.theme.colors.basic;
});
var TabsWrapper = styled.div(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteralLoose(["\n    justify-content: flex-start;\n    flex-direction: column;\n    display: flex;\n"])));
var ButtonSwitcher = styled.div(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteralLoose(["\n    background: ", ";\n    border: 1px solid\n        ", ";\n    margin: 0 auto;\n    width: 100%;\n    height: 50px;\n    bottom: 70px;\n    border-radius: 7px;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding: 5px;\n    box-sizing: border-box;\n    position: sticky;\n    cursor: pointer;\n"])), function (props) {
  return props.theme.name === 'default' ? props.theme.colors.bgDarker : props.theme.colors.bg;
}, function (props) {
  return props.theme.name === 'default' ? 'transparent' : props.theme.colors.bgDarker;
});
var Tab = styled.button(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    height: 100%;\n    font-weight: ", ";\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    z-index: 2;\n    cursor: pointer;\n    border: 0;\n    background: none;\n    color: ", ";\n"])), function (props) {
  return props.theme.fontWeight;
}, function (props) {
  return props.active ? props.theme.colors.basic : props.theme.colors.primaryAction;
});
var Line = styled.div(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteralLoose(["\n    height: 20px;\n    width: 1px;\n    margin-left: 0;\n    display: inline-block;\n    box-sizing: border-box;\n    background: ", ";\n    position: relative;\n    z-index: -1;\n"])), function (props) {
  return props.theme.name === 'default' ? props.theme.colors.primaryAction : props.theme.colors.bgDarker;
});
var ActiveTabPad = styled.div(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteralLoose(["\n    background: ", ";\n    border-radius: 5px;\n    width: 50%;\n    height: 40px;\n    position: absolute;\n    z-index: 1;\n    left: ", ";\n    transition: all 300ms ease;\n"])), function (props) {
  return props.theme.name === 'default' ? props.theme.colors.bg : props.theme.colors.bgDarker;
}, function (props) {
  return props.left;
});

var LINKS = {
  "default": {
    dataPolicy: 'https://intercom.help/25syv/da/articles/3870767-persondatapolitik-for-bet25-a-s',
    termsConds: 'https://intercom.help/25syv/da/articles/3493559-generelle-vilkar-betingelser'
  },
  casinogo: {
    dataPolicy: 'https://intercom.help/casinogo/da/articles/3870784-persondatapolitik-for-25syv-a-s',
    termsConds: 'https://intercom.help/casinogo/da/articles/4660397-vilkar-og-betingelser'
  }
};
var siteByProjectName = {
  rod25: 'casino',
  bet25: 'sport',
  derby25: 'heste',
  casinogo: ''
};
var getLinks = function getLinks(project) {
  if (project === void 0) {
    project = 'default';
  }

  return LINKS[project] === undefined ? LINKS["default"] : LINKS[project];
};

var _path;

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function SvgCheckmarkcircle(props) {
  return /*#__PURE__*/createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/createElement("path", {
    "data-name": "Subtraction 8",
    d: "M23.998 47.977a23.448 23.448 0 01-9.277-1.906A24.474 24.474 0 011.91 33.263a23.541 23.541 0 010-18.56 24.41 24.41 0 0112.795-12.8 23.6 23.6 0 0118.568 0 24.442 24.442 0 0112.822 12.8 23.541 23.541 0 010 18.56 24.461 24.461 0 01-12.809 12.808 23.491 23.491 0 01-9.288 1.906zm-9.293-24.34a1.882 1.882 0 00-1.879 1.926 2.519 2.519 0 00.563 1.528l5.906 7.244a2.463 2.463 0 002.07 1.152 2.284 2.284 0 001.977-1.152L34.401 16.93a3.38 3.38 0 00.59-1.55 1.9 1.9 0 00-2-1.812 2.048 2.048 0 00-1.668 1.084L21.276 30.783l-4.779-6.16a2.027 2.027 0 00-1.792-.986z",
    fill: "#0bc628"
  })));
}

var _g;

function _extends$2() {
  _extends$2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$2.apply(this, arguments);
}

function SvgInfocirclefill(props) {
  return /*#__PURE__*/createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/createElement("g", {
    "data-name": "Group 9158"
  }, /*#__PURE__*/createElement("path", {
    "data-name": "Path 12719",
    d: "M10 20a10.074 10.074 0 0010-10A10.076 10.076 0 009.99 0 10.066 10.066 0 000 10a10.081 10.081 0 0010 10z",
    fill: "#3f7fe9"
  }), /*#__PURE__*/createElement("path", {
    "data-name": "Path 12720",
    d: "M8.312 15.678a.7.7 0 01-.718-.726.713.713 0 01.718-.716h1.2V9.627H8.473a.7.7 0 01-.709-.726.711.711 0 01.709-.716h1.834c.5 0 .766.373.766.922v5.129h1.2a.713.713 0 01.718.716.7.7 0 01-.718.726zm1.621-9.16a1.3 1.3 0 01-1.28-1.333 1.273 1.273 0 112.543 0 1.29 1.29 0 01-1.263 1.333z",
    fill: "#fff"
  }))));
}

var DEPOSIT_LIMITS = {
  daily: {
    name: 'daily',
    APIPropertyKey: 'dailyDepositLimit',
    leftIndent: '5px',
    maxValue: 100000,
    format: '######',
    title: 'Daglig',
    subTitle: 'dag'
  },
  weekly: {
    name: 'weekly',
    APIPropertyKey: 'weeklyDepositLimit',
    leftIndent: '33%',
    maxValue: 700000,
    format: '######',
    title: 'Ugentlig',
    subTitle: 'uge'
  },
  monthly: {
    name: 'monthly',
    APIPropertyKey: 'monthlyDepositLimit',
    leftIndent: '66%',
    maxValue: 3000000,
    format: '#######',
    title: 'Månedlig',
    subTitle: 'måned'
  }
};

var Step3 = function Step3(_ref) {
  var userData = _ref.userData,
      setUserData = _ref.setUserData,
      onSave = _ref.onSave,
      setStep = _ref.setStep,
      _ref$scrollToTop = _ref.scrollToTop,
      scrollToTop = _ref$scrollToTop === void 0 ? function () {} : _ref$scrollToTop,
      setStepValidity = _ref.setStepValidity,
      _ref$serverError = _ref.serverError,
      serverError = _ref$serverError === void 0 ? '' : _ref$serverError,
      _onFocus = _ref.onFocus,
      theme = _ref.theme,
      project = _ref.project,
      minimumDepositLimit = _ref.minimumDepositLimit;
  var LINKS = getLinks(project);

  var _useState = useState(null),
      depositRef = _useState[0],
      setDepositRef = _useState[1];

  var _useState2 = useState({
    depositLimit: '',
    expectBetting: '',
    rulesAccepted: false
  }),
      errors = _useState2[0],
      setErrors = _useState2[1];

  var _useState3 = useState(false),
      showInfoBox = _useState3[0],
      setShowInfoBox = _useState3[1];

  useEffect(function () {
    scrollToTop();
  }, []);
  var depositLimitConfig = DEPOSIT_LIMITS[userData.depositLimitType];
  useEffect(function () {
    if (userData.depositLimit > depositLimitConfig.maxValue) {
      setUserData(_extends({}, userData, {
        depositLimit: depositLimitConfig.maxValue
      }));
    }
  }, [userData.depositLimitType]);

  var checkValue = function checkValue(error) {
    if (error) {
      var _extends2;

      setErrors(_extends({}, errors, (_extends2 = {}, _extends2[error.name] = error.value, _extends2)));
    }
  };

  var isDataValid = function isDataValid() {
    var values = Object.values(pick(userData, ['depositLimit', 'rulesAccepted']));
    return values.every(function (data) {
      return !!data;
    }) && Object.values(errors).every(function (error) {
      return error == false;
    });
  };

  useEffect(function () {
    setStepValidity(isDataValid);
  }, [isDataValid]);

  var onSubmitSuccess = function onSubmitSuccess() {
    return setStep(4);
  };

  var submit = function submit() {
    onSave(onSubmitSuccess);
  };

  var errorMessage = /*#__PURE__*/React__default.createElement(Text, {
    color: "#D10000",
    center: true
  }, serverError, ' ', /*#__PURE__*/React__default.createElement("i", {
    className: "fa fa-exclamation-triangle",
    "aria-hidden": "true"
  }));

  var renderDepositLimitSwitcher = function renderDepositLimitSwitcher() {
    var tabsConfig = Object.keys(DEPOSIT_LIMITS);
    return /*#__PURE__*/React__default.createElement(Fragment, null, serverError ? errorMessage : null, /*#__PURE__*/React__default.createElement(Text, {
      color: theme.colors.basic,
      style: {
        margin: '40px 0 16px',
        fontSize: '20px'
      },
      weight: theme.fontWeight
    }, "S\xE6t en indbetalingsgr\xE6nse"), /*#__PURE__*/React__default.createElement(TabsLabel, {
      padding: "0 0 8px",
      style: {
        fontSize: '14px',
        margin: 0
      }
    }, "V\xE6lg periode og bel\xF8b"), /*#__PURE__*/React__default.createElement(TabsWrapper, null, /*#__PURE__*/React__default.createElement(ButtonSwitcher, null, /*#__PURE__*/React__default.createElement(ActiveTabPad, {
      style: {
        width: 'calc(33% + 1px)',
        left: depositLimitConfig.leftIndent
      }
    }), tabsConfig.map(function (key, index) {
      var tabConfig = DEPOSIT_LIMITS[key];
      return /*#__PURE__*/React__default.createElement(Fragment, {
        key: tabConfig.name
      }, /*#__PURE__*/React__default.createElement(Tab, {
        onClick: function onClick() {
          setUserData(_extends({}, userData, {
            depositLimitType: tabConfig.name
          }));
          setTimeout(function () {
            return depositRef.current.onBlur();
          }, 0);
        },
        active: userData.depositLimitType === tabConfig.name,
        "data-deposit-max-amount": true
      }, tabConfig.title), index < tabsConfig.length - 1 && /*#__PURE__*/React__default.createElement(Line, null));
    }))));
  };

  var formattedBottomLabel = useCallback(function (maxValue) {
    return /*#__PURE__*/React__default.createElement(Fragment, null, "Max. gr\xE6nse er ", /*#__PURE__*/React__default.createElement("b", null, thousandsDots(maxValue)), " kr.", ' ', /*#__PURE__*/React__default.createElement("span", {
      style: {
        textTransform: 'lowercase'
      }
    }, DEPOSIT_LIMITS[userData.depositLimitType].title));
  }, [userData === null || userData === void 0 ? void 0 : userData.depositLimitType]);
  var renderInputExpanderContent = useCallback(function () {
    var _DEPOSIT_LIMITS$userD = DEPOSIT_LIMITS[userData.depositLimitType],
        title = _DEPOSIT_LIMITS$userD.title,
        subTitle = _DEPOSIT_LIMITS$userD.subTitle;
    return /*#__PURE__*/React__default.createElement(ExpanderWrapper, null, /*#__PURE__*/React__default.createElement(ExpanderContent, null, /*#__PURE__*/React__default.createElement(SvgCheckmarkcircle, null), /*#__PURE__*/React__default.createElement(Text, {
      color: theme.colors.basic,
      size: "sm"
    }, title, " gr\xE6nse")), /*#__PURE__*/React__default.createElement(Text, {
      color: theme.colors.active,
      size: "md",
      weight: theme.fontWeight
    }, thousandsDots(userData.depositLimit), " kr. pr. ", subTitle));
  }, [userData === null || userData === void 0 ? void 0 : userData.depositLimitType, userData === null || userData === void 0 ? void 0 : userData.depositLimit]);
  return /*#__PURE__*/React__default.createElement(Fragment, null, renderDepositLimitSwitcher(), /*#__PURE__*/React__default.createElement(ValidatingInput, {
    format: Object.keys(userData.depositLimitType).length > 0 ? userData.depositLimitType.format : depositLimitConfig.format,
    type: "number",
    name: "depositLimit",
    onCheckValue: checkValue,
    validate: "required, numeric, minimum-kr, maximum-kr",
    onChangeHandler: function onChangeHandler(value) {
      setUserData(_extends({}, userData, {
        depositLimit: value
      }));
    },
    altLabel: "kr.",
    allowFirstZero: false,
    maxNumber: depositLimitConfig.maxValue,
    minNumber: minimumDepositLimit,
    value: userData.depositLimit,
    bottomLabel: formattedBottomLabel(depositLimitConfig.maxValue),
    styles: {
      InputWrapper: {
        marginTop: '14px'
      }
    },
    forwardedRef: function forwardedRef(ref) {
      return setDepositRef(ref);
    },
    autoComplete: "new-depositLimit",
    role: "presentation",
    onFocus: function onFocus(elem, validVal) {
      setShowInfoBox(true);

      _onFocus(elem, function (value) {
        setUserData(_extends({}, userData, {
          depositLimit: value
        }));
      }, validVal);
    },
    shouldRevalidateOnBlur: function shouldRevalidateOnBlur(relatedTarget) {
      return relatedTarget ? !relatedTarget.hasAttribute('data-deposit-max-amount') : true;
    },
    inputExpanderStates: ['success'],
    inputExpanderContent: renderInputExpanderContent,
    validateOnChange: true,
    theme: theme.name
  }),  '', showInfoBox && /*#__PURE__*/React__default.createElement(InfoBox, null, /*#__PURE__*/React__default.createElement(SvgInfocirclefill, null), /*#__PURE__*/React__default.createElement(Text, {
    color: theme.colors.basic,
    lineHeight: "21px",
    style: {
      fontSize: '14px'
    }
  }, "Din gr\xE6nse kan s\xE6nkes med \xF8jebliklig virkning og kan h\xE6ves med ", /*#__PURE__*/React__default.createElement("b", null, "24 timers forsinkelse"), ".")), /*#__PURE__*/React__default.createElement(TextRulesWrapper, {
    valid: userData.rulesAccepted,
    linkFontSize: "16px"
  }, /*#__PURE__*/React__default.createElement(RadioWrapper, {
    radioWidth: "100%"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginRight: 0,
      alignItems: 'flex-start'
    }
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "radio",
    name: "rules",
    id: "rules",
    checked: userData.rulesAccepted,
    onChange: function onChange() {
      setUserData(_extends({}, userData, {
        rulesAccepted: !userData.rulesAccepted
      }));
    }
  }), /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "rules"
  }, /*#__PURE__*/React__default.createElement(Text, {
    size: "x15",
    color: theme.colors.basic,
    style: {
      margin: 0
    },
    lineHeight: '21px'
  }, "Jeg accepterer", ' ', /*#__PURE__*/React__default.createElement("a", {
    target: "_blank",
    href: LINKS.termsConds,
    rel: "noreferrer"
  }, "vilk\xE5r & betingelser"), ", samt", ' ', /*#__PURE__*/React__default.createElement("a", {
    target: "_blank",
    href: LINKS.dataPolicy,
    rel: "noreferrer"
  }, "regler for beskyttelse af personlige oplysninger"), "."))))), /*#__PURE__*/React__default.createElement(NextButton, {
    active: !!isDataValid(),
    width: "100%",
    padding: "16px",
    margin: "20px 0",
    disabled: !isDataValid(),
    yellow: true,
    onClick: submit
  }, "N\xE6ste"));
};

var parseFirstName = function parseFirstName(fullName) {
  fullName = fullName.trim();
  var lastIndex = fullName.lastIndexOf(' ');
  return fullName.substring(0, lastIndex);
};
var parseLastName = function parseLastName(fullName) {
  var split = fullName.trim().split(' ');
  return split[split.length - 1];
};
var getBirthday = function getBirthday(cpr) {
  var day = cpr.substr(0, 2);
  var month = cpr.substr(2, 2);
  var year = cpr.substr(4, 2);
  return day + "-" + month + "-19" + year;
};
var getGender = function getGender(cpr) {
  var lastLetter = cpr.slice(-1);

  if (lastLetter % 2 === 0) {
    return 'F';
  } else {
    return 'M';
  }
};
var parseUserDataStep3 = function parseUserDataStep3(userData) {
  var _extends2;

  var depositLimitConfig = DEPOSIT_LIMITS[userData.depositLimitType];
  return omit(_extends({}, userData, (_extends2 = {}, _extends2[DEPOSIT_LIMITS.daily.APIPropertyKey] = null, _extends2[DEPOSIT_LIMITS.weekly.APIPropertyKey] = null, _extends2[DEPOSIT_LIMITS.monthly.APIPropertyKey] = null, _extends2[depositLimitConfig.APIPropertyKey] = userData.depositLimit, _extends2.stepsValidated = _extends({}, userData.stepsValidated, {
    step3: true
  }), _extends2)), ['rulesAccepted']);
};
var serverErrorMapping = {
  LASTNAMEISREQ: 'Det fulde navn er forkert'
};
var parseError = function parseError(error) {
  return typeof error === 'object' ? error.errorMessage : capitalizeFirstLetter(serverErrorMapping[error]) || error;
};

var sha512 = function sha512(message) {
  try {
    var msgBuffer = new TextEncoder().encode(message);
    return Promise.resolve(crypto.subtle.digest('SHA-512', msgBuffer)).then(function (hashBuffer) {
      var hashArray = Array.from(new Uint8Array(hashBuffer));
      return hashArray.map(function (b) {
        return b.toString(16).padStart(2, '0');
      }).join('');
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

var getAPIEnv = function getAPIEnv() {
  return window.location.hostname === 'localhost' ? 'bet25dev.dk' : window.location.hostname;
};
var OLD_AUTH_REST = '/rest/punter/';
var API_PATH = "https://api." + getAPIEnv();
var API_PUNTER_PATH = API_PATH + "/punter/";
var PROD_LOCATIONS = ['terminal.retail.25syv.dk', 'derby.retail.25syv.dk'];
var AUTH_REST_DOMAIN;

if (PROD_LOCATIONS.includes(window.location.hostname)) {
  AUTH_REST_DOMAIN = 'https://retail.25syv.dk';
} else {
  AUTH_REST_DOMAIN = API_PUNTER_PATH;
}

var AuthService = /*#__PURE__*/function () {
  function AuthService() {}

  var _proto = AuthService.prototype;

  _proto.request = function request(requestType, url, data) {
    return makeRequest(requestType, url, data).then(function (response) {
      return response.json();
    }).then(function (data) {
      return data;
    });
  };

  _proto.post = function post(method, data, oldAPI) {
    if (oldAPI === void 0) {
      oldAPI = false;
    }

    var restPath;

    if (this.isTerminal) {
      restPath = AUTH_REST_DOMAIN + API_PUNTER_PATH;
    } else if (oldAPI) {
      restPath = OLD_AUTH_REST;
    } else {
      restPath = API_PUNTER_PATH;
    }

    return this.request('post', restPath + method, data);
  };

  _proto.storePunter = function storePunter(userData, oldAPI) {
    if (oldAPI === void 0) {
      oldAPI = false;
    }

    var defaultValues = {
      currency: 'DKK',
      country: 'DK',
      code_note: "Signupbonus " + userData.project
    };
    userData = {
      userName: userData.userName,
      password: userData.password,
      firstName: parseFirstName(userData.fullName),
      lastName: parseLastName(userData.fullName),
      email: userData.email,
      currency: defaultValues.currency,
      birthDate: getBirthday(userData.cpr),
      gender: getGender(userData.cpr),
      address: userData.pureAddress,
      city: userData.city,
      zip: userData.zip,
      country: defaultValues.country,
      phoneNr: userData.phoneNumber,
      mobileNr: userData.phoneNumber,
      bonusCode: userData.bonusCode,
      bonusCodeNote: defaultValues.code_note,
      mailList: userData.newsletterSub,
      securityAnswer: userData.pinCode,
      expectBetting: userData.expectBetting,
      dailyDepositLimit: userData.dailyDepositLimit,
      weeklyDepositLimit: userData.weeklyDepositLimit,
      monthlyDepositLimit: userData.monthlyDepositLimit
    };
    return this.post('storePunter', userData, oldAPI).then(function (response) {
      if (response.statusCode !== 200 || !response.success) {
        return Promise.reject(response.errorMessage);
      }

      return userData;
    });
  };

  _proto.startMitId = function startMitId(cpr, idp, site) {
    if (site === void 0) {
      site = '';
    }

    var restPath;

    if (this.isTerminal) {
      restPath = AUTH_REST_DOMAIN + '/mitId/start';
    } else if (!site) {
      restPath = "/rest/mitId/start";
    } else {
      restPath = API_PUNTER_PATH + "mitId/start";
    }

    return this.request('post', restPath, {
      cpr: cpr,
      idp: idp,
      channel: this.isTerminal ? 9 : '',
      site: site
    }).then(function (data) {
      return data;
    });
  };

  _proto.checkEmail = function checkEmail(email, oldAPI) {
    var _this = this;

    if (oldAPI === void 0) {
      oldAPI = false;
    }

    var salt = '1238ASvNkjsfaw23v.da!)&efu';
    return sha512(email + salt).then(function (hash) {
      return _this.post('checkEmail', {
        email: email,
        hash: hash
      }, oldAPI);
    });
  };

  _proto.checkUserName = function checkUserName(username, cpr, oldAPI) {
    var _this2 = this;

    if (oldAPI === void 0) {
      oldAPI = false;
    }

    var salt = '1238ASvNkjsfaw23v.da!)&efu';
    return sha512(username + salt).then(function (hash) {
      return _this2.post('checkUsername', {
        username: username,
        cpr: cpr,
        hash: hash
      }, oldAPI);
    });
  };

  _proto.checkRegisterInfo = function checkRegisterInfo(username, cpr, oldAPI) {
    if (oldAPI === void 0) {
      oldAPI = false;
    }

    var salt = '1238ASvNkjsfaw23v.da!)&efu';
    return sha512(username + salt + cpr).then(function (hash) {
      return makeRequest('post', (oldAPI ? OLD_AUTH_REST : AUTH_REST_DOMAIN) + "checkRegisterInfo", {
        username: username,
        cpr: cpr,
        hash: hash
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        return data;
      });
    });
  };

  return AuthService;
}();

var AuthService$1 = new AuthService();

var _g$1;

function _extends$3() {
  _extends$3 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$3.apply(this, arguments);
}

function SvgBack(props) {
  return /*#__PURE__*/createElement("svg", _extends$3({
    "data-name": "Component 118 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45
  }, props), _g$1 || (_g$1 = /*#__PURE__*/createElement("g", {
    "data-name": "Group 3446",
    fill: "none",
    stroke: "#9198aa",
    strokeLinecap: "round",
    strokeWidth: 4.5
  }, /*#__PURE__*/createElement("path", {
    "data-name": "Line 6",
    d: "M20.5 22.5l4.243 4.243"
  }), /*#__PURE__*/createElement("path", {
    "data-name": "Line 7",
    d: "M20.5 22.5l4.243-4.243"
  }))));
}

var _templateObject$3, _templateObject2$3;
var UserAvatar = styled.img(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteralLoose(["\n    margin-top: 5px;\n    vertical-align: middle;\n    display: inline-block;\n    height: 100px;\n    width: 100px;\n    border-radius: 50%;\n    cursor: pointer;\n    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.7);\n"])));
var NavButton = styled(DefaultBtn)(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteralLoose(["\n    margin: 0 20px;\n\n    @media screen and (max-width: 480px) {\n        background: ", ";\n    }\n    &:hover {\n        background: ", ";\n    }\n"])), function (props) {
  return props.theme.colors.bgDarker;
}, function (props) {
  return props.theme.colors.bgDarker;
});
var avatarsCount = 147;

var Avatar = function Avatar(_ref) {
  var path = _ref.path;

  var _useState = useState(1),
      curImage = _useState[0],
      setCurImage = _useState[1];

  var navigationClickHandler = function navigationClickHandler(direction) {
    if (direction === void 0) {
      direction = 'next';
    }

    var arr = Array.from({
      length: avatarsCount
    }, function (_, i) {
      return i + 1;
    });
    var avatarIndex = parseInt(arr.indexOf(curImage), 10);
    var arrLength = arr.length;
    var distance;

    if (direction === 'prev') {
      distance = -1;
    } else {
      distance = 1;
    }

    avatarIndex = (avatarIndex + distance + arrLength) % arrLength;
    setCurImage(arr[avatarIndex]);
    localStorage.setItem('avatar', arr[avatarIndex]);
  };

  useEffect(function () {
    var avatar = localStorage.getItem('avatar');

    if (avatar) {
      setCurImage(avatar);
    }
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      margin: '35px 0 0'
    }
  }, /*#__PURE__*/React__default.createElement(Flex, {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React__default.createElement(NavButton, {
    onClick: function onClick() {
      return navigationClickHandler('prev');
    }
  }, /*#__PURE__*/React__default.createElement(SvgBack, null)), /*#__PURE__*/React__default.createElement(UserAvatar, {
    src: path + curImage + '.png',
    onClick: function onClick() {
      return navigationClickHandler('next');
    }
  }), /*#__PURE__*/React__default.createElement(NavButton, {
    onClick: function onClick() {
      return navigationClickHandler('next');
    }
  }, /*#__PURE__*/React__default.createElement(SvgBack, {
    style: {
      transform: 'rotate(180deg)'
    }
  }))));
};

var _templateObject$4, _templateObject2$4;
var NewsLetterTitle = styled.div(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    top: -26px;\n    left: 8px;\n    color: ", ";\n    font-size: 14px;\n"])), function (props) {
  return props.theme.colors.primary;
});
var BonusCodeWrapper = styled.div(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    color: ", ";\n    padding-left: 10px;\n    p {\n        display: inline-block;\n        text-decoration: underline;\n        cursor: pointer;\n    }\n    span {\n        text-decoration: none;\n        margin-left: 20px;\n        color: ", ";\n        font-size: 14px;\n    }\n"])), function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.active;
});

var Step1 = function Step1(_ref) {
  var _ref$setStep = _ref.setStep,
      setStep = _ref$setStep === void 0 ? function () {} : _ref$setStep,
      _ref$updateUserData = _ref.updateUserData,
      updateUserData = _ref$updateUserData === void 0 ? function () {} : _ref$updateUserData,
      _ref$onEmailExists = _ref.onEmailExists,
      onEmailExists = _ref$onEmailExists === void 0 ? function () {} : _ref$onEmailExists,
      setStepValidity = _ref.setStepValidity,
      userData = _ref.userData,
      setUserData = _ref.setUserData,
      _onFocus = _ref.onFocus,
      isTerminal = _ref.isTerminal,
      terminalEmailExist = _ref.terminalEmailExist,
      theme = _ref.theme,
      avatar = _ref.avatar,
      showBonusCode = _ref.showBonusCode,
      project = _ref.project,
      _ref$oldAPI = _ref.oldAPI,
      oldAPI = _ref$oldAPI === void 0 ? false : _ref$oldAPI,
      _ref$step1Headline = _ref.step1Headline,
      step1Headline = _ref$step1Headline === void 0 ? '' : _ref$step1Headline;
  var LINKS = getLinks(project);

  var _useState = useState(true),
      isPasswordHidden = _useState[0],
      setIsPasswordHidden = _useState[1];

  var _useState2 = useState(0),
      passwordStrength = _useState2[0],
      setPasswordStrength = _useState2[1];

  var _useState3 = useState('Minimum 10 tegn'),
      passwordHint = _useState3[0],
      setPasswordHint = _useState3[1];

  var _useState4 = useState(false),
      isbonusCodeVisible = _useState4[0],
      setIsbonusCodeVisible = _useState4[1];

  var _useState5 = useState({
    email: '',
    password: ''
  }),
      errors = _useState5[0],
      setErrors = _useState5[1];

  var showPassword = function showPassword() {
    setIsPasswordHidden(!isPasswordHidden);
  };

  var passwordChangeHandler = function passwordChangeHandler(value) {
    value = cutEmptyValues(value);
    var strength = 0;
    var hasNumber = /\d/;

    function hasUpperCase(str) {
      return str.toLowerCase() !== str;
    }

    if (value.length < 9) {
      setPasswordHint('Minimum 10 tegn');
    } else if (!hasUpperCase(value)) {
      setPasswordHint('Minimum ét STORT bogstav');
    } else if (!hasNumber.test(value)) {
      setPasswordHint('Minimum ét tal');
    } else {
      setPasswordHint('');
    }

    if (hasNumber.test(value)) strength = strength + 1;
    if (hasUpperCase(value)) strength = strength + 1;
    if (value.length >= 10) strength = strength + 1;
    setPasswordStrength(strength);
    setUserData(_extends({}, userData, {
      password: value
    }));
  };

  var onChangeSubscription = function onChangeSubscription(e) {
    setUserData(_extends({}, userData, {
      newsletterSub: e.target.value
    }));
  };

  var checkValue = function checkValue(error) {
    if (error) {
      var _extends2;

      setErrors(_extends({}, errors, (_extends2 = {}, _extends2[error.name] = error.value, _extends2)));
    }
  };

  var submitHandler = function submitHandler() {
    AuthService$1.checkEmail(userData.email, oldAPI).then(function (res) {
      if (res !== null && res !== void 0 && res.data) {
        var _res$data, _res$data2;

        if ((res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.exist) === false) {
          var cUserData = _extends({}, userData, {
            stepsValidated: _extends({}, userData.stepsValidated, {
              step1: true
            })
          });

          updateUserData(cUserData);
          setStep(2);
        } else if ((res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.exist) === true) {
          var _cUserData = _extends({}, userData, {
            stepsValidated: _extends({}, userData.stepsValidated, {
              step1: false
            })
          });

          updateUserData(_cUserData);
          onEmailExists();

          if (isTerminal) {
            terminalEmailExist(true);
          }
        }
      }
    });
  };

  var checkEmail = function checkEmail(value) {
    var email = cutEmptyValues(value);
    setUserData(_extends({}, userData, {
      email: email,
      userName: email
    }));
  };

  var isDataValid = userData.password && userData.newsletterSub && userData.email && !errors.email && !errors.password;
  useEffect(function () {
    if (userData !== null && userData !== void 0 && userData.password) {
      passwordChangeHandler(userData.password);
    }
  }, []);
  useEffect(function () {
    setStepValidity(isDataValid);
  }, [isDataValid]);
  return /*#__PURE__*/React__default.createElement(Fragment, null, avatar.show && /*#__PURE__*/React__default.createElement(Avatar, {
    path: avatar.path
  }), /*#__PURE__*/React__default.createElement(ValidatingInput, {
    autoFocus: !isTerminal,
    type: "text",
    title: "Email",
    name: "email",
    autoComplete: "new-email",
    onCheckValue: checkValue,
    validate: "required, email",
    value: userData.email,
    onFocus: function onFocus(elem, validVal) {
      _onFocus(elem, checkEmail, validVal);
    },
    onChangeHandler: function onChangeHandler(value) {
      checkEmail(value);
    },
    theme: theme.name
  }), /*#__PURE__*/React__default.createElement(ValidatingInput, {
    onChangeHandler: passwordChangeHandler,
    onCheckValue: checkValue,
    type: isPasswordHidden ? 'password' : 'text',
    value: userData.password,
    title: "Kodeord",
    autoComplete: "new-password",
    validate: "required, password",
    min: 10,
    max: 15,
    onFocus: function onFocus(elem, validVal) {
      _onFocus(elem, passwordChangeHandler, validVal);
    },
    name: "password",
    bottomLabel: passwordHint,
    altLabel: isPasswordHidden ? 'Vis' : 'Skjul',
    altLabelClickHandler: showPassword,
    passwordStrength: passwordStrength,
    theme: theme.name
  }), /*#__PURE__*/React__default.createElement(TextRulesWrapper, {
    valid: userData.newsletterSub === '1' || userData.newsletterSub === '0'
  }, /*#__PURE__*/React__default.createElement(NewsLetterTitle, null, "Nyheder og kampagner"), /*#__PURE__*/React__default.createElement(Text, {
    bold: true,
    color: theme.colors.basic,
    size: "x2",
    style: {
      margin: '0 0 17px',
      fontSize: '18px',
      fontWeight: theme.fontWeight
    }
  }, step1Headline ? step1Headline : 'Få 25 kr. via e-mail'), /*#__PURE__*/React__default.createElement(RadioWrapper, {
    value: userData.newsletterSub,
    wrap: "nowrap",
    marginInside: "0"
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("input", {
    type: "radio",
    value: "1",
    name: "subYes",
    autoComplete: "new-subYes",
    id: "subYes",
    checked: userData.newsletterSub === '1',
    onChange: onChangeSubscription
  }), /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "subYes"
  }, "Ja tak")), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("input", {
    type: "radio",
    value: "0",
    name: "subNo",
    autoComplete: "new-subNo",
    id: "subNo",
    checked: userData.newsletterSub === '0',
    onChange: onChangeSubscription
  }), /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "subNo"
  }, "Nej tak"))), /*#__PURE__*/React__default.createElement(Text, {
    color: theme.colors.primaryAction,
    size: "x02",
    lh: "20",
    style: {
      margin: '20px 0 0 ',
      fontSize: '12px',
      lineHeight: '20px'
    }
  }, "Ved tilmelding gives tilladelse til at Bet25 A/S (herunder CasinoGo) m\xE5 behandle oplysninger om mig og sende mig nyheder og markedsf\xF8ring af vores onlinecasino, v\xE6ddem\xE5l, events, kampagner og konkurrencer via e-mail og sms. Du kan altid tilbagekalde dit samtykke p\xE5", ' ', /*#__PURE__*/React__default.createElement("a", {
    target: "_blank",
    href: "https://www.bet25.dk",
    rel: "noreferrer"
  }, "Bet25.dk"), ' ', "og", ' ', /*#__PURE__*/React__default.createElement("a", {
    target: "_blank",
    href: "https://www.casinogo.dk",
    rel: "noreferrer"
  }, "CasinoGo.dk"), ", samt via vores apps eller via link i nyhedsbreve. L\xE6s mere om regler for beskyttelse af personlige oplysninger her:", ' ', /*#__PURE__*/React__default.createElement("a", {
    target: "_blank",
    href: LINKS.dataPolicy,
    rel: "noreferrer"
  }, "persondatapolitik"))), showBonusCode && /*#__PURE__*/React__default.createElement(BonusCodeWrapper, null, /*#__PURE__*/React__default.createElement("p", {
    onClick: function onClick() {
      setIsbonusCodeVisible(!isbonusCodeVisible);
    }
  }, "Jeg har en bonuskode"), ' ', /*#__PURE__*/React__default.createElement("span", null, "(Valgfrit)")), isbonusCodeVisible && /*#__PURE__*/React__default.createElement(ValidatingInput, {
    title: "Bonuskode",
    type: "text",
    autoComplete: "new-bonusCode",
    value: userData.bonusCode,
    validate: "numeric, min, max, max-length",
    placeholder: "\u0425\u0425\u0425\u0425",
    min: 4,
    max: 4,
    onChangeHandler: function onChangeHandler(value) {
      setUserData(_extends({}, userData, {
        bonusCode: hasNumber.test(value) ? value.match(hasNumber).join('').slice(0, 4) : ''
      }));
    },
    onFocus: function onFocus(elem, validVal) {
      _onFocus(elem, function (value) {
        setUserData(_extends({}, userData, {
          bonusCode: hasNumber.test(value) ? value.match(hasNumber).join('').slice(0, 4) : ''
        }));
      }, validVal);
    },
    theme: theme.name
  }), /*#__PURE__*/React__default.createElement(NextButton, {
    active: !!isDataValid,
    width: "100%",
    padding: "16px",
    margin: "20px auto",
    disabled: !isDataValid,
    yellow: true,
    onClick: submitHandler
  }, "N\xE6ste"));
};

var Step2 = function Step2(_ref) {
  var _ref$setStep = _ref.setStep,
      setStep = _ref$setStep === void 0 ? function () {} : _ref$setStep,
      onCPRExists = _ref.onCPRExists,
      _ref$updateUserData = _ref.updateUserData,
      updateUserData = _ref$updateUserData === void 0 ? function () {} : _ref$updateUserData,
      _ref$scrollToTop = _ref.scrollToTop,
      scrollToTop = _ref$scrollToTop === void 0 ? function () {} : _ref$scrollToTop,
      setStepValidity = _ref.setStepValidity,
      userData = _ref.userData,
      setUserData = _ref.setUserData,
      showError = _ref.showError,
      _onFocus = _ref.onFocus,
      isTerminal = _ref.isTerminal,
      _ref$oldAPI = _ref.oldAPI,
      oldAPI = _ref$oldAPI === void 0 ? false : _ref$oldAPI,
      theme = _ref.theme;

  var _useState = useState({
    userName: '',
    fullName: '',
    phoneNumber: '',
    cpr: ''
  }),
      errors = _useState[0],
      setErrors = _useState[1];

  var _useState2 = useState(true),
      isUserNameDisabled = _useState2[0],
      setIsUserNameDisabled = _useState2[1];

  var _useState3 = useState(userData.userName.length > 2),
      isUserNameValid = _useState3[0],
      setIsUserNameValid = _useState3[1];

  var _useState4 = useState(''),
      userNameErrorValue = _useState4[0],
      setUserNameErrorValue = _useState4[1];

  var _useState5 = useState(''),
      cprErrorValue = _useState5[0],
      setCprErrorValue = _useState5[1];

  var _useState6 = useState(null),
      isCprValid = _useState6[0],
      setIsCprValid = _useState6[1];

  var checkValue = function checkValue(error) {
    if (error) {
      setErrors(function (errors) {
        var _extends2;

        return _extends({}, errors, (_extends2 = {}, _extends2[error.name] = error.value, _extends2));
      });
    }
  };

  var isDataValid = function isDataValid() {
    var values = Object.values(pick(userData, ['userName', 'fullName', 'phoneNumber', 'cpr']));
    return values.every(function (data) {
      return (data === null || data === void 0 ? void 0 : data.length) > 0;
    }) && Object.values(errors).every(function (error) {
      return error == false;
    });
  };

  useEffect(function () {
    scrollToTop();
  }, []);
  useEffect(function () {
    setStepValidity(isDataValid);
  }, [isDataValid]);

  var submitHandler = function submitHandler() {
    setIsUserNameValid(true);
    setUserNameErrorValue('');
    setIsCprValid(true);
    setCprErrorValue('');
    AuthService$1.checkRegisterInfo(userData.userName, userData.cpr, oldAPI).then(function (res) {
      if (res !== null && res !== void 0 && res.data) {
        var _res$data, _res$data2;

        if ((res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.exist) === false) {
          var cUserData = _extends({}, userData, {
            stepsValidated: _extends({}, userData.stepsValidated, {
              step2: true
            })
          });

          updateUserData(cUserData);
          setStep(3);
        } else if ((res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.exist) === true) {
          AuthService$1.checkUserName(userData.userName, userData.cpr, oldAPI).then(function (res) {
            if (res !== null && res !== void 0 && res.data) {
              var _res$data3;

              if ((res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.exist) === true) {
                var _cUserData = _extends({}, userData, {
                  stepsValidated: _extends({}, userData.stepsValidated, {
                    step2: false
                  })
                });

                updateUserData(_cUserData);
                setUserNameErrorValue('Brugernavn er optaget');
                setIsUserNameValid(false);
                showError('Brugernavn er optaget');
              } else {
                var _cUserData2 = _extends({}, userData, {
                  stepsValidated: _extends({}, userData.stepsValidated, {
                    step2: false
                  })
                });

                updateUserData(_cUserData2);
                setCprErrorValue('CPR er optaget');
                setIsCprValid(false);
                onCPRExists && typeof onCPRExists === 'function' ? onCPRExists() : showError('CPR er optaget');
              }
            }
          });
        }
      } else if ((res === null || res === void 0 ? void 0 : res.errorMessage) === 'CPR_ERROR_TO_YOUNG') {
        var _cUserData3 = _extends({}, userData, {
          stepsValidated: _extends({}, userData.stepsValidated, {
            step2: false
          })
        });

        updateUserData(_cUserData3);
        setIsCprValid(false);
        setCprErrorValue('Du skal være 18 år for at kunne oprette en bruger');
        showError('Du skal være 18 år for at kunne oprette en bruger');
      } else if ((res === null || res === void 0 ? void 0 : res.errorMessage) === 'CPR_ERROR_VALIDATION') {
        var _cUserData4 = _extends({}, userData, {
          stepsValidated: _extends({}, userData.stepsValidated, {
            step2: false
          })
        });

        updateUserData(_cUserData4);
        setIsCprValid(false);
        setCprErrorValue('Ugyldigt CPR-nummer');
        showError('Ugyldigt CPR-nummer');
      } else {
        showError('smth went wrong');
      }
    });
  };

  var userNameClickHandler = function userNameClickHandler() {
    if (isUserNameDisabled) {
      setIsUserNameDisabled(!isUserNameDisabled);
      setUserData(_extends({}, userData, {
        userName: userData.userName
      }));
    } else {
      setUserData(_extends({}, userData, {
        userName: userData.email
      }));
      setIsUserNameDisabled(!isUserNameDisabled);
      setErrors(omit(errors, ['userName']));
    }
  };

  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(ValidatingInput, {
    type: "text",
    title: "Brugernavn",
    name: "userName",
    autoComplete: "new-user-name",
    onCheckValue: checkValue,
    validate: "required, min-text, username",
    validateOnChange: true,
    value: userData.userName,
    onChangeHandler: function onChangeHandler(value) {
      setUserData(_extends({}, userData, {
        userName: value,
        stepsValidated: _extends({}, userData.stepsValidated, {
          step2: false
        })
      }));
    },
    min: 3,
    disabled: isUserNameDisabled,
    altLabel: isUserNameDisabled ? 'Ret' : 'Fortryd',
    altLabelClickHandler: userNameClickHandler,
    bottomLabel: "Du kan bruge b\xE5de email og brugernavn til at logge ind.",
    errorMessage: userNameErrorValue,
    setValid: isUserNameValid,
    onFocus: function onFocus(e) {
      _onFocus(e, function (value) {
        setUserData(_extends({}, userData, {
          userName: value,
          stepsValidated: _extends({}, userData.stepsValidated, {
            step2: false
          })
        }));
      });
    },
    theme: theme.name
  }), /*#__PURE__*/React__default.createElement("input", {
    name: "email",
    type: "hidden"
  }), /*#__PURE__*/React__default.createElement(ValidatingInput, {
    onChangeHandler: function onChangeHandler(value) {
      setUserData(_extends({}, userData, {
        fullName: value
      }));
    },
    onCheckValue: checkValue,
    type: "text",
    min: 2,
    title: "Fulde navn",
    validate: "required, min-text, full-name",
    value: userData.fullName,
    name: "fullName",
    autoComplete: "new-full-name",
    autoFocus: !isTerminal,
    onFocus: function onFocus(elem, validVal) {
      _onFocus(elem, function (value) {
        setUserData(_extends({}, userData, {
          fullName: value
        }));
      }, validVal);
    },
    theme: theme.name
  }), /*#__PURE__*/React__default.createElement(ValidatingInput, {
    onChangeHandler: function onChangeHandler(value) {
      setUserData(_extends({}, userData, {
        phoneNumber: value
      }));
    },
    onCheckValue: checkValue,
    type: "number",
    title: "Telefonnummer",
    validate: "required, min, max, numeric",
    min: 8,
    max: 8,
    value: userData.phoneNumber,
    name: "phoneNumber",
    placeholder: "+45",
    autoComplete: "new-phone-number",
    allowEmptyFormatting: true,
    format: "+45 ## ## ## ##",
    onFocus: function onFocus(elem, validVal) {
      _onFocus(elem, function (value) {
        setUserData(_extends({}, userData, {
          phoneNumber: value
        }));
      }, validVal);
    },
    theme: theme.name
  }), /*#__PURE__*/React__default.createElement(ValidatingInput, {
    onChangeHandler: function onChangeHandler(value) {
      setUserData(_extends({}, userData, {
        cpr: value,
        stepsValidated: _extends({}, userData.stepsValidated, {
          step2: false
        })
      }));
    },
    onCheckValue: checkValue,
    type: !isTerminal ? 'number' : '',
    title: "CPR-nummer",
    validate: "required, numeric, min, max",
    value: userData.cpr,
    name: "cpr",
    min: "10",
    max: "10",
    bottomLabel: "Dit CPR-nummer sikrer os, at du er over 18 \xE5r.",
    format: !isTerminal ? '###### - ####' : null,
    placeholder: "DDMM\xC5\xC5 - XXXX",
    autoComplete: "new-cpr",
    allowEmptyFormatting: true,
    mask: !isTerminal ? ['D', 'D', 'M', 'M', 'Å', 'Å', 'X', 'X', 'X', 'X'] : '',
    setValid: isCprValid,
    onFocus: function onFocus(elem, validVal) {
      _onFocus(elem, function (value) {
        setUserData(_extends({}, userData, {
          cpr: value,
          stepsValidated: _extends({}, userData.stepsValidated, {
            step2: false
          })
        }));
      }, validVal);
    },
    errorMessage: cprErrorValue,
    theme: theme.name
  }), /*#__PURE__*/React__default.createElement(NextButton, {
    active: !!isDataValid(),
    width: "100%",
    padding: "16px",
    margin: "20px 0",
    disabled: !isDataValid(),
    yellow: true,
    onClick: submitHandler
  }, "N\xE6ste"));
};

var _defs, _g$2;

function _extends$4() {
  _extends$4 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$4.apply(this, arguments);
}

function SvgMitId(props) {
  return /*#__PURE__*/createElement("svg", _extends$4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.973,
    height: 14
  }, props), _defs || (_defs = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
    id: "mitID_svg__a"
  }, /*#__PURE__*/createElement("path", {
    "data-name": "Rectangle 3302",
    fill: "#fff",
    d: "M0 0h51.973v14H0z"
  })))), _g$2 || (_g$2 = /*#__PURE__*/createElement("g", {
    "data-name": "Group 3273",
    clipPath: "url(#mitID_svg__a)",
    fill: "#fff"
  }, /*#__PURE__*/createElement("path", {
    "data-name": "Path 1063",
    d: "M41.802.212h2.266c5.553 0 7.9 3.021 7.9 6.8s-2.351 6.8-7.9 6.8h-2.266z"
  }), /*#__PURE__*/createElement("path", {
    "data-name": "Path 1064",
    d: "M40.106 13.81c-.338-4.193-2.847-5.949-5.933-5.949s-5.595 1.756-5.933 5.949z"
  }), /*#__PURE__*/createElement("path", {
    "data-name": "Path 1065",
    d: "M37.458 3.293A3.284 3.284 0 1134.174 0a3.289 3.289 0 013.284 3.293"
  }), /*#__PURE__*/createElement("path", {
    "data-name": "Path 1066",
    d: "M10.429.704L6.492 6.893 2.533.704H0v13.1h2.661V5.357l3.767 5.634h.085l3.724-5.634v8.447h2.682V.704z"
  }), /*#__PURE__*/createElement("path", {
    "data-name": "Path 1067",
    d: "M20.817 6.402H19.37V4.268h1.447V1.686h2.618v2.582h2.086v2.134h-2.086v4.184a.969.969 0 001.086 1.088 2.258 2.258 0 001.149-.321v2.348a3.993 3.993 0 01-1.7.3c-1.937 0-3.15-.96-3.15-3.073z"
  }), /*#__PURE__*/createElement("path", {
    "data-name": "Path 1068",
    d: "M18.188 1.568A1.565 1.565 0 1116.624 0a1.567 1.567 0 011.564 1.568"
  }), /*#__PURE__*/createElement("path", {
    "data-name": "Rectangle 3301",
    d: "M15.304 4.268h2.639v9.54h-2.639z"
  }))));
}

var LOGIN_TYPES = {
  MIT_ID: 'mitid',
  MIT_ID_DEMO: 'mitid_demo'
};

var Step4 = function Step4(_ref) {
  var _ref$userData = _ref.userData,
      userData = _ref$userData === void 0 ? {} : _ref$userData,
      _ref$scrollToTop = _ref.scrollToTop,
      scrollToTop = _ref$scrollToTop === void 0 ? function () {} : _ref$scrollToTop,
      theme = _ref.theme,
      _ref$site = _ref.site,
      site = _ref$site === void 0 ? '' : _ref$site;

  var _useState = useState(''),
      signupError = _useState[0],
      setSignupError = _useState[1];

  useEffect(function () {
    scrollToTop();
  }, []);

  var finishSignUp = function finishSignUp(loginType) {
    return AuthService$1.startMitId(userData.cpr, loginType, site).then(function (response) {
      if (response.statusCode !== 200 || !response.success) {
        return Promise.reject(response.errorMessage);
      }

      console.log(response);
      window.location.href = response.data;
    })["catch"](function (error) {
      setSignupError(typeof error === 'object' ? error.errorMessage : error);
    });
  };

  var errorMessage = signupError ? /*#__PURE__*/React__default.createElement(Text, {
    color: "#D10000",
    center: true
  }, signupError, ' ', /*#__PURE__*/React__default.createElement("i", {
    className: "fa fa-exclamation-triangle",
    "aria-hidden": "true"
  })) : null;
  return /*#__PURE__*/React__default.createElement(Fragment, null, errorMessage, /*#__PURE__*/React__default.createElement(Text, {
    center: true,
    color: theme.colors.basic,
    style: {
      textAlign: 'center',
      fontSize: '16px',
      padding: 0,
      margin: '32px auto 0'
    }
  }, "V\xE6lg metode"), /*#__PURE__*/React__default.createElement(FourthStepBtn, {
    mitid: true,
    onClick: function onClick() {
      return finishSignUp(LOGIN_TYPES.MIT_ID);
    }
  }, /*#__PURE__*/React__default.createElement(SvgMitId, {
    style: {
      marginRight: '10px'
    }
  }), "Bekr\xE6ft med MitID"));
};

var _path$1, _path2;

function _extends$5() {
  _extends$5 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$5.apply(this, arguments);
}

function SvgClose(props) {
  return /*#__PURE__*/createElement("svg", _extends$5({
    "data-name": "Luk knap",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45
  }, props), _path$1 || (_path$1 = /*#__PURE__*/createElement("path", {
    "data-name": "Line 6",
    fill: "none",
    stroke: "#9198aa",
    strokeLinecap: "round",
    strokeWidth: 4.5,
    d: "M18.257 18.257l8.485 8.485"
  })), _path2 || (_path2 = /*#__PURE__*/createElement("path", {
    "data-name": "Line 7",
    fill: "none",
    stroke: "#9198aa",
    strokeLinecap: "round",
    strokeWidth: 4.5,
    d: "M18.258 26.742l8.485-8.485"
  })));
}

var defaultTheme = {
  name: 'default',
  fontFamily: "'Roboto Condensed', sans-serif",
  fontWeight: '900',
  colors: {
    bg: '#ffffff',
    bgDarker: '#eceff6',
    bgGrey: '#F7F8FC',
    basic: '#333333',
    primary: '#575c69',
    primaryAction: '#9198aa',
    primaryActionHover: '#e9ebee',
    secondary: '#FFF7CD',
    secondaryAction: '#FFD401',
    active: '#0bc628',
    link: '#1b4ef7',
    bgBlue: '#E4EFFE',
    borderBlue: '#D3E3FB'
  }
};
var dark = {
  name: 'dark',
  fontFamily: "'Kanit',sans-serif",
  fontWeight: '400',
  colors: {
    bg: '#121212',
    bgDarker: '#262626',
    basic: '#ffffff',
    primary: '#BEBEBE',
    primaryAction: '#818181',
    primaryActionHover: '#e9ebee',
    secondary: '#522200',
    secondaryAction: '#F77705',
    active: '#51A351',
    link: '#97D800',
    bgBlue: '#3F7FE91A',
    borderBlue: '#3F7FE91A'
  }
};

var themesMap = {
  "default": defaultTheme,
  dark: dark
};
var signupSteps = ['Konto', 'Profil', 'Sikkerhed', 'Bekræft'];

var scrollToRef = function scrollToRef(ref) {
  var _ref$current, _ref$current2, _ref$current3;

  (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.scrollTo(0, 0);
  (_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  (_ref$current3 = ref.current) === null || _ref$current3 === void 0 ? void 0 : _ref$current3.scrollIntoView(true);
};

var Signup = function Signup(_ref) {
  var project = _ref.project,
      onEmailExists = _ref.onEmailExists,
      onCPRExists = _ref.onCPRExists,
      onClose = _ref.onClose,
      showError = _ref.showError,
      scrollableWrapperRef = _ref.scrollableWrapperRef,
      _ref$defaultStep = _ref.defaultStep,
      defaultStep = _ref$defaultStep === void 0 ? 1 : _ref$defaultStep,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      _ref$onFocus = _ref.onFocus,
      onFocus = _ref$onFocus === void 0 ? function () {} : _ref$onFocus,
      _ref$isTerminal = _ref.isTerminal,
      isTerminal = _ref$isTerminal === void 0 ? false : _ref$isTerminal,
      _ref$showBonusCode = _ref.showBonusCode,
      showBonusCode = _ref$showBonusCode === void 0 ? true : _ref$showBonusCode,
      _ref$avatar = _ref.avatar,
      avatar = _ref$avatar === void 0 ? {
    show: false,
    path: ''
  } : _ref$avatar,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      _ref$addressSpinnerPo = _ref.addressSpinnerPopup,
      addressSpinnerPopup = _ref$addressSpinnerPo === void 0 ? function () {} : _ref$addressSpinnerPo,
      _ref$terminalEmailExi = _ref.terminalEmailExist,
      terminalEmailExist = _ref$terminalEmailExi === void 0 ? function () {} : _ref$terminalEmailExi,
      _ref$minimumDepositLi = _ref.minimumDepositLimit,
      minimumDepositLimit = _ref$minimumDepositLi === void 0 ? 50 : _ref$minimumDepositLi,
      step1Headline = _ref.step1Headline;

  var _useState = useState(defaultStep),
      currentStep = _useState[0],
      setCurrentStep = _useState[1];

  var _useState2 = useState(false),
      stepValidity = _useState2[0],
      setStepValidity = _useState2[1];

  var _useState3 = useState(''),
      serverError = _useState3[0],
      setServerError = _useState3[1];

  var chosenTheme = themesMap[theme];
  var projectName = project || 'bet25';
  useEffect(function () {
    scrollToTop();
    AuthService$1.isTerminal = isTerminal;
  }, []);

  var scrollToTop = function scrollToTop() {
    scrollableWrapperRef && scrollToRef(scrollableWrapperRef);
  };

  var _useState4 = useState({
    userName: '',
    email: '',
    password: '',
    newsletterSub: '',
    bonusCode: '',
    fullName: '',
    address: '',
    city: '',
    zip: '',
    phoneNumber: '',
    cpr: '',
    dailyDepositLimit: null,
    weeklyDepositLimit: null,
    monthlyDepositLimit: null,
    expectBetting: '',
    pinCode: '',
    loseLimit: 10000,
    project: projectName,
    pureAddress: '',
    depositLimit: '',
    depositLimitType: DEPOSIT_LIMITS.daily.name,
    rulesAccepted: false,
    stepsValidated: {
      step1: false,
      step2: false,
      step3: false,
      step4: false
    }
  }),
      userData = _useState4[0],
      setUserData = _useState4[1];

  var selectStep = function selectStep(step) {
    var validatedStep;
    currentStep > step ? validatedStep = step : validatedStep = currentStep;

    if (userData.stepsValidated['step' + validatedStep] === true && (step < currentStep || stepValidity && step - currentStep === 1)) {
      setCurrentStep(step);
    }
  };

  var backBtnHandler = function backBtnHandler() {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  var updateUserData = function updateUserData(payload) {
    setUserData(_extends({}, userData, payload));
  };

  var submitHandlerStep3 = function submitHandlerStep3(onSuccess) {
    var params = parseUserDataStep3(userData);
    updateUserData(params);
    AuthService$1.storePunter(params, !siteByProjectName[projectName]).then(onSuccess)["catch"](function (error) {
      var msg = parseError(error);
      console.log(error);
      setServerError(msg);
      scrollToTop();
      showError(msg);
    });
  };

  var getTemplateByStep = function getTemplateByStep(step) {
    if (step === void 0) {
      step = 1;
    }

    if (step === 1) {
      return /*#__PURE__*/React__default.createElement(Step1, {
        onEmailExists: onEmailExists,
        terminalEmailExist: terminalEmailExist,
        setStep: setCurrentStep,
        updateUserData: updateUserData,
        setStepValidity: setStepValidity,
        setUserData: setUserData,
        userData: userData,
        onFocus: onFocus,
        isTerminal: isTerminal,
        theme: chosenTheme,
        avatar: avatar,
        showBonusCode: showBonusCode,
        project: projectName,
        oldAPI: !siteByProjectName[projectName],
        step1Headline: step1Headline
      });
    } else if (step === 2) {
      return /*#__PURE__*/React__default.createElement(Step2, {
        setStep: setCurrentStep,
        onCPRExists: onCPRExists,
        signupData: userData,
        updateUserData: updateUserData,
        setStepValidity: setStepValidity,
        setUserData: setUserData,
        userData: userData,
        showError: showError,
        scrollToTop: scrollToTop,
        onFocus: onFocus,
        isTerminal: isTerminal,
        addressSpinnerPopup: addressSpinnerPopup,
        oldAPI: !siteByProjectName[projectName],
        theme: chosenTheme
      });
    } else if (step === 3) {
      return /*#__PURE__*/React__default.createElement(Step3, {
        setStep: setCurrentStep,
        setStepValidity: setStepValidity,
        setUserData: setUserData,
        userData: userData,
        scrollToTop: scrollToTop,
        serverError: serverError,
        onSave: submitHandlerStep3,
        onFocus: onFocus,
        isTerminal: isTerminal,
        theme: chosenTheme,
        project: projectName,
        minimumDepositLimit: minimumDepositLimit
      });
    } else if (step === 4) {
      return /*#__PURE__*/React__default.createElement(Step4, {
        setStep: setCurrentStep,
        setStepValidity: setStepValidity,
        userData: userData,
        scrollToTop: scrollToTop,
        theme: chosenTheme,
        site: siteByProjectName[projectName]
      });
    }
  };

  return /*#__PURE__*/React__default.createElement(ThemeProvider, {
    theme: chosenTheme
  }, /*#__PURE__*/React__default.createElement(SignUpWrapper, null, /*#__PURE__*/React__default.createElement(SignUpTop, null, currentStep > 1 ? /*#__PURE__*/React__default.createElement(BackBtn, {
    onClick: backBtnHandler
  }, /*#__PURE__*/React__default.createElement(SvgBack, null)) : null, /*#__PURE__*/React__default.createElement(Text, {
    center: true,
    size: "x2",
    color: chosenTheme.colors.basic,
    style: {
      margin: 0,
      textAlign: 'center',
      width: '100%',
      fontWeight: chosenTheme.fontWeight,
      fontSize: '18px'
    }
  }, title || 'Opret en 25-konto'), /*#__PURE__*/React__default.createElement(CloseSignupBtn, {
    onClick: onClose
  }, /*#__PURE__*/React__default.createElement(SvgClose, {
    alt: "Close button"
  }))), /*#__PURE__*/React__default.createElement(Stepper, {
    currentStep: currentStep,
    steps: signupSteps,
    progressColor: chosenTheme.colors.secondaryAction,
    selectStep: selectStep,
    userData: userData,
    submitHandlerStep3: submitHandlerStep3,
    theme: chosenTheme
  }), getTemplateByStep(currentStep)));
};

export default Signup;
//# sourceMappingURL=index.modern.js.map
